import { defineComponent as U, onMounted as q, onActivated as G, onDeactivated as J, computed as T, ref as w, h as I, mergeProps as Q } from "vue";
import { useSsrAdapter as Z } from "./ghl-ui.es694.js";
import j from "./ghl-ui.es780.js";
import { ensureMaybeTouch as ee, ensureWheelScale as P } from "./ghl-ui.es781.js";
import { cssrAnchorMetaName as te, c as W } from "./ghl-ui.es695.js";
import { FinweckTree as le } from "./ghl-ui.es782.js";
import ie from "./ghl-ui.es735.js";
import { depx as Y, pxfy as H } from "./ghl-ui.es783.js";
import { beforeNextFrameOnce as ne } from "./ghl-ui.es776.js";
const oe = W(".v-vl", {
  maxHeight: "inherit",
  height: "100%",
  overflow: "auto",
  minWidth: "1px"
  // a zero width container won't be scrollable
}, [
  W("&:not(.v-vl--show-scrollbar)", {
    scrollbarWidth: "none"
  }, [
    W("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", {
      width: 0,
      height: 0,
      display: "none"
    })
  ])
]), ve = U({
  name: "VirtualList",
  inheritAttrs: !1,
  props: {
    showScrollbar: {
      type: Boolean,
      default: !0
    },
    items: {
      type: Array,
      default: () => []
    },
    // it is suppose to be the min height
    itemSize: {
      type: Number,
      required: !0
    },
    itemResizable: Boolean,
    itemsStyle: [String, Object],
    visibleItemsTag: {
      type: [String, Object],
      default: "div"
    },
    visibleItemsProps: Object,
    ignoreItemResize: Boolean,
    onScroll: Function,
    onWheel: Function,
    onResize: Function,
    defaultScrollKey: [Number, String],
    defaultScrollIndex: Number,
    keyField: {
      type: String,
      default: "key"
    },
    // Whether it is a good API?
    // ResizeObserver + footer & header is not enough.
    // Too complex for simple case
    paddingTop: {
      type: [Number, String],
      default: 0
    },
    paddingBottom: {
      type: [Number, String],
      default: 0
    }
  },
  setup(i) {
    const E = Z();
    oe.mount({
      id: "vueuc/virtual-list",
      head: !0,
      anchorMetaName: te,
      ssr: E
    }), q(() => {
      const { defaultScrollIndex: e, defaultScrollKey: t } = i;
      e != null ? z({ index: e }) : t != null && z({ key: t });
    });
    let g = !1, b = !1;
    G(() => {
      if (g = !1, !b) {
        b = !0;
        return;
      }
      z({ top: B.value, left: R });
    }), J(() => {
      g = !0, b || (b = !0);
    });
    const p = T(() => {
      const e = /* @__PURE__ */ new Map(), { keyField: t } = i;
      return i.items.forEach((l, o) => {
        e.set(l[t], o);
      }), e;
    }), u = w(null), d = w(void 0), c = /* @__PURE__ */ new Map(), m = T(() => {
      const { items: e, itemSize: t, keyField: l } = i, o = new le(e.length, t);
      return e.forEach((s, r) => {
        const n = s[l], a = c.get(n);
        a !== void 0 && o.add(r, a);
      }), o;
    }), h = w(0);
    let R = 0;
    const B = w(0), _ = ie(() => Math.max(m.value.getBound(B.value - Y(i.paddingTop)) - 1, 0)), $ = T(() => {
      const { value: e } = d;
      if (e === void 0)
        return [];
      const { items: t, itemSize: l } = i, o = _.value, s = Math.min(o + Math.ceil(e / l + 1), t.length - 1), r = [];
      for (let n = o; n <= s; ++n)
        r.push(t[n]);
      return r;
    }), z = (e, t) => {
      if (typeof e == "number") {
        k(e, t, "auto");
        return;
      }
      const { left: l, top: o, index: s, key: r, position: n, behavior: a, debounce: f = !0 } = e;
      if (l !== void 0 || o !== void 0)
        k(l, o, a);
      else if (s !== void 0)
        A(s, a, f);
      else if (r !== void 0) {
        const N = p.value.get(r);
        N !== void 0 && A(N, a, f);
      } else
        n === "bottom" ? k(0, Number.MAX_SAFE_INTEGER, a) : n === "top" && k(0, 0, a);
    };
    let y, x = null;
    function A(e, t, l) {
      const { value: o } = m, s = o.sum(e) + Y(i.paddingTop);
      if (!l)
        u.value.scrollTo({
          left: 0,
          top: s,
          behavior: t
        });
      else {
        y = e, x !== null && window.clearTimeout(x), x = window.setTimeout(() => {
          y = void 0, x = null;
        }, 16);
        const { scrollTop: r, offsetHeight: n } = u.value;
        if (s > r) {
          const a = o.get(e);
          s + a <= r + n || u.value.scrollTo({
            left: 0,
            top: s + a - n,
            behavior: t
          });
        } else
          u.value.scrollTo({
            left: 0,
            top: s,
            behavior: t
          });
      }
    }
    function k(e, t, l) {
      u.value.scrollTo({
        left: e,
        top: t,
        behavior: l
      });
    }
    function D(e, t) {
      var l, o, s;
      if (g || i.ignoreItemResize || V(t.target))
        return;
      const { value: r } = m, n = p.value.get(e), a = r.get(n), f = (s = (o = (l = t.borderBoxSize) === null || l === void 0 ? void 0 : l[0]) === null || o === void 0 ? void 0 : o.blockSize) !== null && s !== void 0 ? s : t.contentRect.height;
      if (f === a)
        return;
      f - i.itemSize === 0 ? c.delete(e) : c.set(e, f - i.itemSize);
      const S = f - a;
      if (S === 0)
        return;
      r.add(n, S);
      const v = u.value;
      if (v != null) {
        if (y === void 0) {
          const F = r.sum(n);
          v.scrollTop > F && v.scrollBy(0, S);
        } else if (n < y)
          v.scrollBy(0, S);
        else if (n === y) {
          const F = r.sum(n);
          f + F > // Note, listEl shouldn't have border, nor offsetHeight won't be
          // correct
          v.scrollTop + v.offsetHeight && v.scrollBy(0, S);
        }
        L();
      }
      h.value++;
    }
    const O = !ee();
    let M = !1;
    function X(e) {
      var t;
      (t = i.onScroll) === null || t === void 0 || t.call(i, e), (!O || !M) && L();
    }
    function C(e) {
      var t;
      if ((t = i.onWheel) === null || t === void 0 || t.call(i, e), O) {
        const l = u.value;
        if (l != null) {
          if (e.deltaX === 0 && (l.scrollTop === 0 && e.deltaY <= 0 || l.scrollTop + l.offsetHeight >= l.scrollHeight && e.deltaY >= 0))
            return;
          e.preventDefault(), l.scrollTop += e.deltaY / P(), l.scrollLeft += e.deltaX / P(), L(), M = !0, ne(() => {
            M = !1;
          });
        }
      }
    }
    function K(e) {
      if (g || V(e.target) || e.contentRect.height === d.value)
        return;
      d.value = e.contentRect.height;
      const { onResize: t } = i;
      t !== void 0 && t(e);
    }
    function L() {
      const { value: e } = u;
      e != null && (B.value = e.scrollTop, R = e.scrollLeft);
    }
    function V(e) {
      let t = e;
      for (; t !== null; ) {
        if (t.style.display === "none")
          return !0;
        t = t.parentElement;
      }
      return !1;
    }
    return {
      listHeight: d,
      listStyle: {
        overflow: "auto"
      },
      keyToIndex: p,
      itemsStyle: T(() => {
        const { itemResizable: e } = i, t = H(m.value.sum());
        return h.value, [
          i.itemsStyle,
          {
            boxSizing: "content-box",
            height: e ? "" : t,
            minHeight: e ? t : "",
            paddingTop: H(i.paddingTop),
            paddingBottom: H(i.paddingBottom)
          }
        ];
      }),
      visibleItemsStyle: T(() => (h.value, {
        transform: `translateY(${H(m.value.sum(_.value))})`
      })),
      viewportItems: $,
      listElRef: u,
      itemsElRef: w(null),
      scrollTo: z,
      handleListResize: K,
      handleListScroll: X,
      handleListWheel: C,
      handleItemResize: D
    };
  },
  render() {
    const { itemResizable: i, keyField: E, keyToIndex: g, visibleItemsTag: b } = this;
    return I(j, {
      onResize: this.handleListResize
    }, {
      default: () => {
        var p, u;
        return I("div", Q(this.$attrs, {
          class: ["v-vl", this.showScrollbar && "v-vl--show-scrollbar"],
          onScroll: this.handleListScroll,
          onWheel: this.handleListWheel,
          ref: "listElRef"
        }), [
          this.items.length !== 0 ? I("div", {
            ref: "itemsElRef",
            class: "v-vl-items",
            style: this.itemsStyle
          }, [
            I(b, Object.assign({
              class: "v-vl-visible-items",
              style: this.visibleItemsStyle
            }, this.visibleItemsProps), {
              default: () => this.viewportItems.map((d) => {
                const c = d[E], m = g.get(c), h = this.$slots.default({
                  item: d,
                  index: m
                })[0];
                return i ? I(j, {
                  key: c,
                  onResize: (R) => this.handleItemResize(c, R)
                }, {
                  default: () => h
                }) : (h.key = c, h);
              })
            })
          ]) : (u = (p = this.$slots).empty) === null || u === void 0 ? void 0 : u.call(p)
        ]);
      }
    });
  }
});
export {
  ve as default
};
